// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"354":"project","462":"legal"}[chunkId] || chunkId) + "." + {"177":"30fe9913","238":"a75fece1","354":"b3a8e9b6","462":"b70903d8","592":"2a967963","700":"645e4246","878":"b81112d8"}[chunkId] + ".js";
};